import React from 'react'
import get from 'lodash/get'
import Helmet from 'react-helmet'
import Waypoint from 'react-waypoint'
import Header from '../components/Header'
import pic005 from '../assets/images/live-bands.jpg'
import pic007 from '../assets/images/traditional-irish-banner.jpg'
import YoutubeEmbedVideo from "youtube-embed-video"
import pic006 from '../assets/images/pic006.jpg'
import contbanner from '../assets/images/cont-music.jpg'
import LoadingOverlay from 'react-loading-overlay'

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      stickyNav: false,
      active: true
    }
  }

  componentDidMount() {
    this.timer = setTimeout(() =>
      this.setState({ active: false }),
      1500);
  }

  componentWillUnmount() {
    clearTimeout(this.timer)
  }

  _handleWaypointEnter= () => {
    this.setState(() => ({ stickyNav: false }));
  }

  _handleWaypointLeave = () => {
    this.setState(() => ({ stickyNav: true }));
  }
  render() {

    return (
      <div>
        <Helmet

          title={get(this, 'props.data.site.siteMetadata.title')} />
          <meta name="description" content="harmlessnoise.ie offers news about the latest music releases that Ireland has to offer.
          Having searched for the best new artists and songs in Ireland, they are bought here for you to enjoy. We give voice to these new artists and help them find a platform to expose their musical concepts" />
        <Header />
        <Waypoint
          onEnter={this._handleWaypointEnter}
          onLeave={this._handleWaypointLeave}>
        </Waypoint>


        <div id="main">

          <section id="intro" className="main">
            <div className="spotlight">
              <div className="content main-home-wrapper">
                <header className="major">
                  <h2>News about the latest releases</h2>
                </header>
                <p>We give voice to these new artists and help them find a platform to expose their musical concepts.
                This site also celebrates the traditional and is for all those people who have a passion for music, with a
                focus on Irish music in all its forms. </p>
              </div>
            </div>
          </section>

          <section id="first" className="main special">
            <LoadingOverlay
              {...this.props}
              active={this.state.active}
              background='#232924'
              >
                <YoutubeEmbedVideo
                  videoId="2Z_TheGgFWI"
                  suggestions={true}
                  className="video-wrapper"
                />
            </LoadingOverlay>
            <br/>
            <br/>
            <header className="major">
              <h3>Traditional Irish music</h3>
            </header>
              <h4>Irish Traditional Music is at the heart of Irish culture and history and remains alive and vital a tradition.
              Yet it does not stay still, it is open to change, even though the core values are conservative. The aim of harmlessnoise.ie is to reflect what is happening in
              Irish music in contemporary society, which includes the celebration of traditional Irish songs.</h4>
              <h4>From commercial recordings of
              traditional tunes, to experimentation with other musical cultures,
              this site will keep you informed about upcoming tours, events and also festivals from the diverse world of Irish music. </h4>
          </section>

          <section id="second" className="main">
            <LoadingOverlay
              {...this.props}
              active={this.state.active}
              background='#232924'
              >
                <YoutubeEmbedVideo videoId="QOm30Ijv50k" suggestions={true} className="video-wrapper" />
          </LoadingOverlay>
            <br/>
            <br/>
            <header className="major">
              <h3>Contemporary Irish music</h3>
            </header>
            <p>Mainstream Irish music has also been changed by musicians such as Dublin rapper <a href="https://www.thefader.com/2017/05/02/rejjie-snow-dublin-300-dear-annie-interview" rel="follow" target="_blank">Rejjie Snow who over the past few years has broken into the US market</a>. The new generation of musicians are a sign of Ireland’s evolving society. No longer insular, agricultural, rural and contentedly Catholic, Ireland is now a lively, “outward-looking” place, open to change and opportunity. This leads to music that mixes hip-hop and R&B, an African feel and diverse influences like <b>Nirvana</b>, <b>Panic at the Disco</b> and <b>Feist</b>.</p>
          </section>

          <section id="third" className="main">
            <div className="spotlight">
              <div className="content">
                <header className="major">
                  <h3>Diffusion Lab</h3>
                </header>
                <h4>The original plan for Diffusion Lab was to produce songs, but it soon became a place for artist development when artists such as Soulé, Erica Cody and Jafaris began arriving, though the two co-founders were inexperienced in artist development at the time.</h4>
                <p>Labels are reporting increasing interest in both contemporary and traditional Irish music, making it a sector of the music industry that has had successful years. One Irish label doing particularly well is Diffusion Lab which is a “creative station” as well as Ireland’s premier Hip-Hop and RnB label.
                Launched in April 2016, within a year it had signed its brightest stars, Jafaris and Soulé and was producing music videos to rival other major labels.
                </p>

              </div>
              <span className="image img-responsive"><img src={pic006} alt="" /></span>
            </div>
          </section>

          <section id="cta" className="main special">
            <LoadingOverlay
              {...this.props}
              active={this.state.active}
              background='#232924'
              >
                <YoutubeEmbedVideo videoId="WiFM4kxIBtc" suggestions={true} className="video-wrapper" />
            </LoadingOverlay>
            <br/>
            <br/>
            <header className="major">
              <h3>Explore further</h3>
              <p>Now, Diffusion Lab will help develop a song for the artist to take elsewhere or release in-house where there is now management and design.</p>
            </header>
          </section>

          <div id="main">
            <section id="content" className="main">
              <span className="image main"><img src={contbanner} alt="" /></span>
              <h3>Fusion music</h3>
              <p>Squead are one of several groups who are pioneers in Ireland, fusing trap, rap, R&B, pop, jazz and electronics. Squead’s song Zoo of the New was inspired by a Sylvia Plath poem, while Christian music is a big influence on their chords and harmonies. Like many groups, the uploading of their music onto a growing number of internet services including SoundCloud has generated a lot of interest which has led to invitations to play at indie festivals where profiles are raised and the market opened up. </p>

              <p>With increasing popularity in Irish music, artists such as Erica Cody, Simi Crowns, Jafaris, Charlotte Headon and the Neomadic crew, among others, are redefining what it is to make Irish music. Irish music is no longer solely associated with indie, folk, rock and bodhrán-thrumming ceilidhs, though this music will never go away and will always be celebrated.</p>
              <hr/>

              <img src={pic005} className="image img-responsive" alt="live venues ireland" />
              <br/>
              <br/>
              <h3>Live venues</h3>
              <p>While indie acts have historically been dominant in most live venues, the climate is changing and hip-hop and underground artists are becoming more widely known. This new wave of artists are outward-looking and global-sounding. They are Irish to the core without fitting the mainstream media cliché of an Irish figure, since they’ve grown up in multicultural homes. </p>

              <p>Previously Irish exports have overtly shown their heritage, from the songs of U2, Boomtown Rats, Sinéad O’Connor or the region-specific rhymes of northside rappers such as Costello and Lethal Dialect, but the stereotype of Ireland being a land of music where every girl plays a fiddle in an Irish band remains strong, though hopefully such one-dimensional caricatures will soon be a thing of the past. </p>
              <hr/>

              <img src={pic007} className="image img-responsive" alt="live venues ireland" />
              <br/>
              <br/>
              <h3>Traditional Irish music live</h3>
              <p>Traditional Irish music can be heard in pubs across Ireland.  A traditional seisún is best defined as an informal gathering of musicians, which can be someone playing a guitar and before long being joined by others on the fiddle, flute, banjo and bodhran.</p>

              <p>Traditional music differs across the country. In County Clare where the style of traditional music reflects the landscape, taking things a little slower, but still having a good craic with pubs packed with locals and visitors almost every night listening and dancing to Irish music. In the summer months between May and September, Ireland also hosts more than 30 festivals across the country, some of them world famous such as Electric Picnic which sells out in hours to smaller, free events. </p>
              <hr/>

              <h3>Dublin live</h3>
              <p>Dublin City’s Temple Bar district in the city centre is the capital’s cultural quarter. The cobbled streets here are where Dublin comes to party and here you can listen to traditional live music from early evening through to closing time.</p>
              <p>You can expect some dancing inside too, particularly during the Temple Bar Traditional Music Festival. This annual event sees Temple Bar fill with musicians from all over Ireland and overseas and every pub fills up with music, dancing and song. The streets are lined with buskers and a festival vibe grips the entire area. </p>
              <hr/>
              <h3>The All-Ireland Fleadh</h3>
              <p>If you want to see and hear the best names in Irish music the <a href="https://www.irishmirror.ie/whats-on/music-nightlife-news/drogheda-fleadh-cheoil-2018-irelands-13073493" rel="follow" target="_blank">biggest gathering of traditional Irish musicians in the world</a> takes place at the Fleadh Cheoil na hEireann (All-Ireland Fleadh).</p>
            </section>
          </div>

          <section id="cta" className="main special">
            <header className="major">
              <h3><b>Experience the culture</b></h3>
              <p>More than 2000 competitors travel from around Ireland and abroad to battle through heats to win the final competition of this Irish music, dancing and culture. The atmosphere is electric, with plenty of friendly banter and street entertainment for everyone.</p>
            </header>

          </section>

        </div>

      </div>
    )
  }
}

Index.propTypes = {
  route: React.PropTypes.object,
}

export default Index

export const pageQuery = graphql`
  query IndexQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js